import { MarkdownEntryForm } from './MarkdownEntryForm';
import { CONCERN_VALIDATION } from '@promo/shared';

interface ConcernFormProps {
  initialContent?: string;
  initialAuthorEmail?: string;
  readOnly?: boolean;
  isSubmitting?: boolean;
  onSubmit: (content: string, authorEmail: string) => void;
  onCancel: () => void;
  onDelete?: () => void;
}

export function ConcernForm({
  initialContent = '',
  initialAuthorEmail = '',
  readOnly = false,
  isSubmitting = false,
  onSubmit,
  onCancel,
  onDelete,
}: ConcernFormProps) {
  const handleSave = (content: string) => {
    onSubmit(content, initialAuthorEmail.toLowerCase());
  };

  return (
    <div className="space-y-4">
      <MarkdownEntryForm
        label="Opportunity"
        placeholder="Describe the opportunity for growth with actionable suggestions"
        initialContent={initialContent}
        onSubmit={handleSave}
        onCancel={onCancel}
        onDelete={onDelete}
        isSubmitting={isSubmitting}
        readOnly={readOnly}
        maxLength={CONCERN_VALIDATION.MAX_CONTENT_LENGTH}
      />
    </div>
  );
}
